import { add } from "redux/errors/errorsSlice";
import { onError } from "apollo-link-error";
import { getGraphqlUrl } from "config";
import { InMemoryCache } from "apollo-cache-inmemory";
import ApolloClient from "apollo-client";
import { createHttpLink } from "apollo-link-http";
import { ApolloLink } from "apollo-link";
import { setContext } from "apollo-link-context";
import { getGraphqlAccessKey } from "config";
import store from "redux/store";

const errorLink: ApolloLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors)
    graphQLErrors.forEach(({ message, locations, path }) => {
      store.dispatch(add(graphQLErrors[0]));
    });
  if (networkError) {
    store.dispatch(add({ message: "Network error!" }));
  }
});

const httpLink: ApolloLink = createHttpLink({
  uri: getGraphqlUrl(),
});

const headerLink: ApolloLink = setContext((request) => ({
  headers: {
    "X-Hasura-Access-Key": getGraphqlAccessKey(),
  },
}));

const link = ApolloLink.from([headerLink, errorLink, httpLink]);

const client = new ApolloClient({
  link,
  cache: new InMemoryCache(),
});

export default client;
